import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-cash-solutions.component.scss';
var FormItemBusinessCashSolutions = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCashSolutions, _super);
    function FormItemBusinessCashSolutions(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessCashSolutions.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-business-cash-solutions__button');
        // fields
        this.emailField = this.element.querySelector("input[name=email]");
        this.recipientField = this.element.querySelector("input[name=recipient]");
        this.isSBCustomer = Array.from(this.element.querySelectorAll("input[name=banking-with-standard-bank]"));
        this.cashSolutionsProvince = this.element.querySelector("select[name=province]");
        this.isSBCustomerValue = "";
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        if (this.cashSolutionsProvince) {
            this.updateCashSolutionsEmail();
        }
    };
    FormItemBusinessCashSolutions.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            _this.businessCashSolutionsValidations();
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.isSBCustomer) {
            this.isSBCustomer.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.isSBCustomerValue = _radio.value;
                });
            });
        }
        if (this.cashSolutionsProvince) {
            this.cashSolutionsProvince.addEventListener("change", function (pEvent) {
                _this.updateCashSolutionsEmail();
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
            _this.resetForm();
        }, false);
    };
    FormItemBusinessCashSolutions.prototype.updateCashSolutionsEmail = function () {
        if (this.recipientField) {
            this.emailField.value = "website@standardbank.co.za";
            switch (this.cashSolutionsProvince.value) {
                case "Gauteng":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Eastern Cape":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Free State":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Kwazulu Natal":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Limpopo":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Mpumalanga":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "North West":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Northern Cape":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                case "Western Cape":
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
                default:
                    this.recipientField.value = "cashsolutionsleads@standardbank.co.za";
                    break;
            }
        }
    };
    FormItemBusinessCashSolutions.prototype.submitForm = function (pForm) {
        var _this = this;
        var _product = this.form.querySelector("input[name=product]");
        var _subject = this.form.querySelector("input[name=subject]");
        var _recipient = this.form.querySelector("input[name=recipient]");
        var _email = this.form.querySelector("input[name=email]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _phoneNumber = this.form.querySelector("input[name=phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _companyName = this.form.querySelector("input[name=company-name]");
        var _province = this.form.querySelector("select[name=province]");
        var _isSBCustomer = this.isSBCustomerValue;
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _postData = {
            'product': (_product ? _product.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'email': (_email ? _email.value : ""),
            'first-name': (_firstname ? _firstname.value : ""),
            'last-name': (_lastName ? _lastName.value : ""),
            'phone-number': (_phoneNumber ? _phoneNumber.value : ""),
            'email-address': (_emailAddress ? _emailAddress.value : ""),
            'company-name': (_companyName ? _companyName.value : ""),
            'province': (_province ? _province.value : ""),
            'banking-with-standard-bank': (_isSBCustomer ? _isSBCustomer : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO"))
        };
        this.showDisplayView("loader");
        // variables
        var url = "/sites/services/CashSolutionsForm.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (pResponse) {
            // service ok
            if (!pResponse) {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
                _this.showDisplayView("error");
            }
            else if (pResponse.data) {
                if (pResponse.data.toString().toLowerCase().includes("invalid")) {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                    _this.showDisplayView("error");
                }
                else {
                    _this.analyticsService.dtmFormComplete('complete', pResponse.data);
                    _this.showDisplayView("success");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.showDisplayView("error");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    // -- CUSTOM BUSINESS CASH SOLUTIONS VALIDATIONS -- //
    FormItemBusinessCashSolutions.prototype.businessCashSolutionsValidations = function () {
        var radioDetailsErrorDetails = "This field is required";
        var validationErrors = false;
        // Radio Details Selection Error
        var isSBCustomerSelectionGroup = this.isSBCustomer[0].closest(".form__group");
        // Buy Own Details Selection Error
        if (!isSBCustomerSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.isSBCustomerValue === "") {
                validationErrors = true;
                isSBCustomerSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                isSBCustomerSelectionGroup.appendChild(_errorDiv);
            }
        }
    };
    FormItemBusinessCashSolutions.prototype.resetForm = function () {
        this.isSBCustomerValue = '';
    };
    FormItemBusinessCashSolutions.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemBusinessCashSolutions;
}(Base));
export { FormItemBusinessCashSolutions };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-cash-solutions/form-item-business-cash-solutions.component.ts
// module id = 853
// module chunks = 0